<template>
  <div class="main bgc-fff c-333 fs-18 ff-as">
    <div class="banner p-r">
      <div class="banner-img bgs-cover"></div>
      <div class="banner-text p-a c-c m-a ta-c c-fff">
        <h1 class="m-0 fs-50">Geospatial</h1>
        <div class="c-ddd lh-15 fs-26"></div>
      </div>
    </div>

    <section class="area-1 pl-60 pr-60 ta-c">
      <div class="m-a c-59 lh-15">
        Measure the world with our precision technology.Surveying, measuring, mapping, and 3D modeling, we use precision
        technology to serve professionals in various industries. Including hardware and software, FJD Trion offers
        accurate and reliable geospatial solutions for customers.
      </div>
    </section>

    <section class="area-3 product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c">— Geospatial —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <a class="li-a" href="/product/trion-s1-3d-lidar-scanner">
            <h3 class="">FJD Trion S1 <br />3D LiDAR Scanner</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Trion S1 3D Lidar Scanner"
                v-lazy="require('@/assets/images/industry/Trion S1 3D Lidar Scanner.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a class="li-a" href="/product/trion-v1-series-rtk-rover">
            <h3 class="">FJD Trion V1 Series <br />RTK Rover</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="trion-v1-series-rtk-rover"
                v-lazy="require('@/assets/images/industry/trion-v1-series-rtk-rover.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
        <li>
          <a class="li-a" href="/product/aerial-mapper">
            <h3 class="">FJD Trion O1 <br />AerialMapper</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="trion-v1-series-rtk-rover"
                v-lazy="require('@/assets/images/industry/AerialMapper.png')"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </a>
        </li>
      </ul>
    </section>

    <!-- <section class="area-3 product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c fw-500">— Geospatial —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <nuxt-link class="li-a" to="/product/trion-s1-3d-lidar-scanner">
            <h3 class="">Trion S1 3D LiDAR Scanner</h3>
            <i class="reveal"
              ><img
                width="100%"
                height="100%"
                alt="Trion S1 3D Lidar Scanner"
                src="@/assets/images/industry/Trion S1 3D Lidar Scanner.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
      </ul>
    </section> -->
    <!-- <section class="area-4">
        <div class="area-4-content d-f jc-sb">
          <div class="left-img"></div>
          <div class="right-content">
            <div class="d-f  ai-fs">
              <img alt="Accuracy" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 4)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Ccircle cx='20' cy='20' r='16'/%3E%3Cpath stroke-linecap='round' d='M20 0v8M20 32v8M0 20h8M32 20h8'/%3E%3Ccircle cx='20' cy='20' r='5'/%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Accuracy</h3>
              <p>With high density and resolution data，our products deliver centimeter-level results.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Efficiency" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg stroke='%23262626' stroke-width='2'%3E%3Cpath d='M24.259 10.104c2.935 1.61 5.539 3.552 7.812 5.825 2.273 2.273 4.214 4.877 5.825 7.812l-10.4 10.4a9.643 9.643 0 0 1-13.638-13.637l10.4-10.4z' stroke-linejoin='round'/%3E%3Cpath d='M24.493 9.87l12.354-2.48a3.197 3.197 0 0 1 3.764 3.763l-2.48 12.354' stroke-linecap='round'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M24.103 23.897l-13.66 13.66'/%3E%3Cpath d='M31.3 30.336l1.085 6.171a.533.533 0 0 1-.148.47l-7.228 7.227a.533.533 0 0 1-.862-.156l-3.466-7.637M17.664 16.7l-6.171-1.085a.533.533 0 0 0-.47.148l-7.227 7.228a.533.533 0 0 0 .156.862l7.637 3.466'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Efficiency</h3>
              <p>Our instruments and solutions deliver high performance，speed and accuracy to boost your productivity to new level.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Cost-Effective and Time-Saving" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg transform='translate(6 6)' stroke='%23262626' stroke-width='2'%3E%3Crect x='1' y='1' width='34' height='34' rx='6'/%3E%3Cg transform='translate(6.75 7)'%3E%3Ccircle cx='11.5' cy='3.5' r='3.5'/%3E%3Ccircle cx='3.5' cy='17' r='3.5'/%3E%3Ccircle cx='19' cy='17' r='3.5'/%3E%3Cpath d='M15.214 9.5l2.236 3.913M12.5 17h-5m-.66-5.845l2.583-4.52' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Flexibility </h3>
              <p>Indoor outdoor and underground, even the sky with drones and helicopter.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Safety and Stability" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg stroke-width='2'%3E%3Cpath d='M7.5 11.139L24 6l16.5 5.139v9.33c0 10.223 0 16.364-16.498 22.531C7.5 36.833 7.5 30.69 7.5 20.465v-9.326z' stroke='%23191923' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M18.328 21.93h11.344c1.139 0 2.062.924 2.062 2.063v6.153c0 1.139-.923 2.062-2.062 2.062H18.328a2.062 2.062 0 0 1-2.062-2.062v-6.153c0-1.139.923-2.062 2.062-2.062z' stroke='%23262626' stroke-linejoin='round'/%3E%3Cpath d='M19.36 21.93v-3.072a3.094 3.094 0 0 1 3.093-3.094h3.094a3.094 3.094 0 0 1 3.094 3.094v3.073' stroke='%23262626'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Safety and Stability</h3>
              <p>Safely capture data in harsh locations and keep harm away.</p>
             </div>
            </div>


          </div>
        </div>
     </section> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  /* pc端样式 */
  @media screen and (min-width: 768px) {
    .main {
      margin-top: 3.958vw;
    }

    /* banner */
    .banner-img {
      /* padding-top: 26.0416vw; */
      padding-top: 3.6rem;
      background-position: top center;
      background-image: url('@/assets/images/business/p4-d.jpg');
    }
    .banner-text {
      display: block;
      /* width: 52.0833vw;
        top: 50%;
        left: 15.1vw;
        text-align: left;
        transform: translate(0, -50%); */
    }
    .banner-text h1 {
      margin-bottom: 15px;
    }

    /* area-1 */
    /* .area-1, */
    .area-2 {
      padding-top: 1rem;
    }
    .area-1 {
      padding: 0.48rem 18.75vw 0.8rem 18.75vw;
    }
    .area-1 li i {
      width: 5.2083vw;
      height: 5.2083vw;
      display: block;
      margin: 0 auto 15px;
    }
    .area-1 ul {
      padding: 5.625vw 20px 0;
    }

    /* area-2 / area-3 */
    .product-mod h2 {
      margin-bottom: 0.62rem;
    }
    .product-mod li {
      width: 5.92rem;
      height: 5.6rem;
      padding: 0.62rem 0.56rem 0.48rem;
      background-color: #fafafa;
      box-sizing: border-box;
      margin-right: 0.16rem;
    }
    .product-mod li:last-child {
      margin-right: 0;
    }
    .product-mod li i {
      display: block;
      margin: 0.16rem 0;
    }
    .product-mod li h3 {
      font-size: 0.28rem;
      font-weight: 500;
      color: #262626;
      /* line-height: 0.42rem; */
      /* margin-bottom: 0.16rem; */
    }

    .product-mod li a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 4.15rem;
    }

    .product-mod li h3 b {
      display: block;
    }
    .product-mod li span {
      font-size: 0.16rem;
      border: 1px solid #262626;
      margin: 0 auto;
      padding: 0.06rem 0.16rem 0.06rem 0.2rem;
    }
    .product-mod li span em {
      color: #262626;
    }
    .product-mod .more b {
      width: 12px;
      height: 12px;
      margin-left: 5px;
      transition: transform 0.3s;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23262626' stroke-linecap='round' stroke-linejoin='round' d='M4.5 10l4-4-4-4' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
    .product-mod li a:hover b {
      transform: translateX(6px);
    }
    .product-mod li a:hover img {
      transform: scale(1.05);
    }
    .product-mod li img {
      transition: transform 0.3s ease-out;
    }

    .area-3 {
      margin-bottom: 1.2rem;
    }

    .area-4 {
      width: 12rem;
      margin: 0 auto;
      padding-bottom: 1.2rem;
    }
    .area-4-content {
      flex-direction: row-reverse;
    }
    .left-img {
      width: 6.8rem;
      background-image: url('@/assets/images/industry/geospatial-bottom-img.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-clip: border-box;
    }
    .right-content {
      margin-right: 0.24rem;
    }
    .right-content > div {
      margin-bottom: 0.76rem;
    }

    .right-content img {
      margin-right: 0.24rem;
    }
    .right-content h3 {
      height: 0.36rem;
      font-size: 0.24rem;
      color: #262626;
      line-height: 0.36rem;
      margin-bottom: 0.08rem;
    }
    .right-content p {
      height: 0.52rem;
      font-size: 0.18rem;
      color: #595959;
      line-height: 0.26rem;
    }
  }
  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
    .fs-50 {
      font-size: 40px;
    }
    .fs-40 {
      font-size: 30px;
    }
    .fs-26 {
      font-size: 24px;
    }
    /* .product-mod li h3 {
      font-size: 24px;
    } */
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
    .fs-50 {
      font-size: 30px;
    }
    .fs-40 {
      font-size: 26px;
    }
    .fs-26 {
      font-size: 20px;
    }
    .banner-text {
      width: 70%;
      top: 50%;
    }
    .area-1 li i {
      width: 80px;
      height: 80px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
      font-size: 20px;
    } */
    .product-mod li span {
      font-size: 14px;
    }
  }

  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
    .fs-50 {
      font-size: 28px;
    }
    .fs-40 {
      font-size: 24px;
    }
    .fs-26 {
      font-size: 18px;
    }
    .fs-18 {
      font-size: 16px;
    }
    .banner-text {
      width: 90%;
      top: 50%;
    }
    .area-1 li i {
      width: 70px;
      height: 70px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
      font-size: 18px;
    } */
    .product-mod li span {
      font-size: 14px;
    }
  }
</style>
